import $ from 'jquery';
import CancelablePromise from 'p-cancelable';

function getRequestVerificationToken() {
  const $input = document.querySelector('input[name="__RequestVerificationToken"]');

  if (!$input) {
    throw new Error('Unable to find anti-forgery token input element');
  }

  return $input.value;
}

function request(ajaxOptions) {
  let jqXHR;
  let requestAborted = false;

  const promise = new CancelablePromise((onCancel, resolve, reject) => {
    onCancel(() => {
      requestAborted = true;
      jqXHR.abort();
    });

    jqXHR = $.ajax(ajaxOptions)
      .done(resolve)
      .fail(() => {
        if (requestAborted) {
          return;
        }

        reject(jqXHR);
      });
  });

  return promise;
}

function post(url, data) {
  const options = Object.assign({ dataType: 'json', contentType: 'application/json', method: 'POST' }, { url });

  if (data) {
    options.data = JSON.stringify(data);
  }

  return request(options);
}

function postWithRequestVerificationToken(url, data = {}) {
  const options = Object.assign({ dataType: 'json', contentType: 'application/x-www-form-urlencoded', method: 'POST' }, { url });

  options.data = Object.assign(data, {
    __RequestVerificationToken: getRequestVerificationToken(),
  });

  return request(options);
}

function get(url, data = {}) {
  const options = Object.assign({ dataType: 'json', method: 'GET' }, { url, data });

  return request(options);
}

function put(url, data = {}) {
  const options = Object.assign({ dataType: 'json', method: 'PUT' }, { url, data });

  return request(options);
}


export default {
  post,
  postWithRequestVerificationToken,
  get,
  put,
};



// WEBPACK FOOTER //
// ./src/utils/ajax.js